module.exports = __webpack_public_path__ + "img/Attendance.88d14fcc.png";